import { observable, action, makeObservable, set } from 'mobx';

import { LoyaltyCardType } from '../../shared/support/modelTypes';

export interface LoyaltyCardFormStoreType {
	model: LoyaltyCardType;
	list: Array<any>;
	isLoading: boolean;
	isNew: boolean;
	isChanged: boolean;
	responseCode: number;
	responseHistoryCode: number;
	pluralName: string;
	selectedItems: Array<any>;
	filterInclude?: Array<any>;
	isFirstLoad: boolean;
	name: string;
	setValue(model: any, key: string, value: any): void;
}

class LoyaltyCardFormStore implements LoyaltyCardFormStoreType {
	constructor() {
		makeObservable(this, {
			model: observable,
			list: observable,
			isLoading: observable,
			isNew: observable,
			responseCode: observable,
			responseHistoryCode: observable,
			isChanged: observable,
			pluralName: observable,
			selectedItems: observable,
			isFirstLoad: observable,
			name: observable,
			filterInclude: observable,
			setValue: action
		});
	}

	model = {
		partnerId: null,
		cardNumber: '',
		statusId: 'loyalty_card_statuses.valid',
		name: { ru: '' },
		displayName: null,
		priority: null,
		deleted: false,
		ownerType: 'OrmLoyaltyCardKind',
		ownerId: '',
		status: {
			id: 'loyalty_card_statuses.valid',
			keyId: 'valid',
			ownerId: 'loyalty_card_statuses',
			name: {
				ru: 'Действует',
				id: '35437670-d1f7-4752-9343-df9f6849d7f2'
			},
			description: null,
			priority: 0,
			predefined: true,
			predefinedName: 'LoyaltyCardStatusesValid',
			predefinedVersion: 0
		}
	};
	list = [];
	isLoading = false;
	isNew = false;
	responseCode = 0;
	responseHistoryCode = 0;
	isChanged = false;
	pluralName = 'loyaltyCards';
	selectedItems = [] as Array<any>;
	isFirstLoad = true;
	name = 'OrmLoyaltyCard';
	filterInclude = ['partner', 'status'];
	setValue(model: any, key: string, value: any) {
		set(model, key, value);
	}
}

export const loyaltyCardFormStore = new LoyaltyCardFormStore();

export default LoyaltyCardFormStore;
